import { Box, Stack, SxProps, Theme, Typography, useTheme } from "@mui/material";
import { SenecBaseTheme } from "src/styles/senecBaseTheme";

import { DataSeriesUnit } from "src/components/monitoring/commonTypes";

interface YAxisLegendProps {
    variant: "left" | "right";
    chartType: "line" | "bar";
    yLegendValues: string[];
    unit: DataSeriesUnit;
    height?: number;
    typographyStyleOverrides?: SxProps<Theme>;
}

export const YAxisLegend = ({
    variant,
    chartType,
    yLegendValues,
    unit,
    height = 337.5,
    typographyStyleOverrides = {},
}: YAxisLegendProps) => {
    const theme: SenecBaseTheme = useTheme();
    const yAxisPadding = { xsMobile: chartType === "bar" ? "0px" : "16px", tablet: "16px" };
    return (
        <Stack
            data-testid={"y-axis-" + variant}
            left={yAxisPadding}
            right={yAxisPadding}
            style={{
                position: "absolute",
                bottom: 0,
                justifyContent: "space-between",
                height: height,
            }}
        >
            {yLegendValues.map((legendValue, index) => (
                <Box key={`${legendValue} ${index}`} sx={{ display: "flex", alignItems: "center", position: "relative" }}>
                    <Box
                        style={{
                            height: "19px",
                            width: "100%",
                            position: "absolute",
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <Box
                            ml={variant == "left" ? 2 : "auto"}
                            mr={variant == "right" ? 2 : "auto"}
                            sx={{
                                position: "relative",
                            }}
                        >
                            <Typography
                                variant={"body1Responsive"}
                                data-testid={`y-axis-label-${variant}-${index}`}
                                sx={{
                                    color: theme.palette.senecSecondary.neutralGray50,
                                    width: "fit-content",
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    zIndex: "21",
                                    visibility: legendValue.toString() === "0" && index != 0 ? "hidden" : "unset",
                                    ...typographyStyleOverrides,
                                }}
                            >
                                {`${legendValue}${index === 0 ? " " + unit : ""}`}
                            </Typography>
                            <Typography
                                variant={"body1Responsive"}
                                sx={{
                                    color: theme.palette.senecPrimary.white,
                                    width: "fit-content",
                                    position: "relative",
                                    top: 0,
                                    left: 0,
                                    zIndex: "20",
                                    WebkitTextStroke: `3px ${theme.palette.senecPrimary.white}`,
                                    visibility: legendValue.toString() === "0" && index != 0 ? "hidden" : "unset",
                                    ...typographyStyleOverrides,
                                }}
                            >
                                {`${legendValue}${index === 0 ? " " + unit : ""}`}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            ))}
        </Stack>
    );
};
